//
// Things that are blank: null, undefined, "", 0, false, [], {}, Map(), Set()
//
// Also see:
//
// https://github.com/toss/es-toolkit/blob/main/src/compat/predicate/isEmpty.ts
// https://developer.mozilla.org/en-US/docs/Glossary/Falsy
//
export function isBlank(value: unknown): boolean {
  // falsy values are blank
  if (!value) return true;

  // truthy primitive? (boolean, number, string, etc.)
  if (typeof value !== "object") return false;

  // value is an object of some kind
  if (Array.isArray(value)) return value.length === 0;
  if (isPlainObject(value)) return Object.keys(value).length === 0;
  if (value instanceof Map || value instanceof Set) return value.size === 0;
  if (value instanceof Set) return value.size === 0;

  // edge case, assume present
  return false;
}

// the opposite of isBlank
export function isPresent(value: unknown): boolean {
  return !isBlank(value);
}
